import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReplaySubject, Observable } from 'rxjs';
import { Service } from './service';
import { Init } from '../models/init.model';
import { UserInit } from '../models/user-init.model';
import { Gateway, Gateways } from 'src/app/shared/models/cart/gateway.model';
import { map } from 'rxjs/operators';
import { State } from '../models/state.model';
import { AuthService } from 'src/app/auth/services/auth.service';
import { ReferralService } from './referral.service';
import { ServerCacheService } from './server-cache.service';
import { UtilsService } from './utils.service';
import { TransferStateHttpParams } from '../interceptors/http-transfer.interceptor';
import { ErrorsService } from './errors.service';

@Injectable({
  providedIn: 'root'
})
export class InitService extends Service {

  data: ReplaySubject<Init> = new ReplaySubject<Init>(1);

  constructor(
    http: HttpClient,
    private auth: AuthService,
    private referral: ReferralService,
    private cacheService: ServerCacheService,
    private utils: UtilsService,
    private errorsService: ErrorsService
  ) {
    super(http);
  }

  fetch() {

    this.http.get<Init>(this.url + '/snack/v1/init').subscribe(data => {
      // Recreate Gateway objects. Objects returned from the server contain
      // only data and don't contain the methods we defined in the model.
      data.gateways = data.gateways.map(g => Object.assign(new Gateway(), g));
      this.data.next(data);
    }, error => {
      this.errorsService.track(error);
      this.utils.disableResponseCache();
    });

    if (this.auth.isLoggedIn()) {
      this.utils.disableResponseCache();
      let cachedUserInit: UserInit = this.cacheService.get('userInit', null);
      if (cachedUserInit) {
        this.cacheService.remove('userInit');
        this.auth.autoLogin(cachedUserInit.user);
      } else {
        this.http.post<UserInit>(this.url + '/snack/v1/userInit', {}, { params: new TransferStateHttpParams(true) }).subscribe(data => {
          if (!this.utils.isBrowser) {
            this.cacheService.set('userInit', data);
          }
          this.auth.autoLogin(data.user);
        });
      }
    } else {
      this.auth.logout(false);
    }
  }

  getGateway(id: Gateways): Observable<Gateway> {
    return this.data.pipe(map(init => {
      return init.gateways.find(g => g.id === id);
    }));
  }

  getStates(countryCode: string) {
    return this.http.get<State[]>(this.url + '/snack/v1/payments/countries/' + countryCode + '/states');
  }

}
